var render, staticRenderFns
import script from "./total_adjust.vue?vue&type=script&lang=js"
export * from "./total_adjust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f66fe44')) {
      api.createRecord('0f66fe44', component.options)
    } else {
      api.reload('0f66fe44', component.options)
    }
    
  }
}
component.options.__file = "found/views/dms/views/record_manage/discount_goods_examine/form/total_adjust.vue"
export default component.exports